module.exports = __webpack_public_path__ + "static/media/user_image_2.f40f679a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/images/user_images/user_image_2.jpg
// module id = 1200
// module chunks = 0